import { MutatingDots, Circles } from "react-loader-spinner";

const Loader = ({
  primaryColor = "#2b5ee1",
  secondaryColor = "#2b5fe177",
  radius = "12.5",
}) => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Circles
        height="80"
        width="80"
        color={primaryColor}
        ariaLabel="circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
};

export default Loader;
